import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';



import IpmIcon from '../../images/transparent.png';
import Button from '@material-ui/core/Button';
// import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Paper from '@material-ui/core/Paper';

//Alerta
import Alerta from '../common/Alerta';


//Redirect page if login
import { Redirect } from 'react-router-dom';

//validators
import {validateUsername, validateField,validateEmail} from '../common/redux/validators'


//country
import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';
import Countries from '../common/redux/countries';


/*Styling */
const styles = theme => ({
  "@global":{
    body:{
      backgroundColor:"#243043"
    }
  },
  main: {
    width: '70%',
    minHeight:'80%',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: '70%',
      minHeight:'80%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    backgroundColor:"#2B3648",
    margin:0,
    width:90,
    height:90,
    minWidth:90, 
    minHeight:90
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  myGrid:{
    marginTop: theme.spacing.unit * 5
  }
});


export class DefaultPage extends Component {
  static propTypes = {
    register: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);


    if(Countries[0].hasOwnProperty("code")){
      Countries.forEach( function(country) {
        country['label'] = country['name'];
        country['value'] = country['code'];
        delete country['name'];
        delete country['code'];
      });
    }

    this.state = {
      user:{ username: '', password: '', email:''},
      person:{names:'', surnames:''},
      company:{name:'', address:'', country:'',phone_number:''},
      showPassword: false,
      errores: {},
      formValid: false,
      openAlert:false,
      AlertaMessage:"No se pudo crear el usuario.",
      registerSuccess:true
    };


    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.handleChangePerson = this.handleChangePerson.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
    this.handleChangeClientCountry=this.handleChangeClientCountry.bind(this);
  }


  doRegister = () =>{
    this.props.actions.doRegister(this.state.user, this.state.person, this.state.company)
    .then((response)=> 
    {
     if(localStorage.getItem("logged")=== true)
     {
      //  console.log("wtf");
      }else{
        // console.log(this.props)
        this.setState({AlertaMessage:response.data.message,openAlert:true});
      }
      this.cleanInfo();
    }).catch((err) => {
      this.setState({AlertaMessage:"Error interno. Intente más tarde",openAlert:true});
    });
  }
  
  cleanInfo = () => {
    let usuario = this.state.user;
    usuario.password = '';
    usuario.username = '';
    usuario.password2 = '';
    usuario.email = '';
    let persona = this.state.person;
    persona.names='';
    persona.surnames='';
    this.setState({
      user: usuario,
      person:persona
    });
  };

   handleChangeUser(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let usuario = this.state.user;
    usuario[name] = value;
    this.setState({
      user: usuario,
    });
    this.validateForm();
  }

  handleChangePerson(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let persona = this.state.person;
    persona[name] = value;
    this.setState({
      person: persona,
    });
    this.validateForm();
  }

  handleChangeCompany(event) 
  {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let company = this.state.company;
    company[name] = value;
    this.setState({
      company:company,
    });
    this.validateForm();
  }

  
  validateForm = () => {
    let errores = {};
    let formValid = true;
    if (!validateUsername(this.state.user.username)) {
      errores.username = "Must don't have spaces";
      formValid = false;
    }
    if(this.state.user.password!== this.state.user.password2){
      errores.password2 = "The password confirmation didn't match";
      formValid = false;
    }
    if (!validateField(this.state.user.username)) {
      errores.username = 'Required field';
      formValid = false;
    }
    if (!validateField(this.state.user.password)) {
      errores.password = 'Required field';
      formValid = false;
    }

    if (!validateField(this.state.user.password2)) {
      errores.password2 = 'Required field';
      formValid = false;
    }

    if (!validateField(this.state.person.names)) {
      errores.names = 'Required field';
      formValid = false;
    }
    if (!validateField(this.state.person.surnames)) {
      errores.surnames = 'Required field';
      formValid = false;
    }
    if(!validateField(this.state.person.surnames)){
      errores.surnames = 'Required field';
      formValid = false;
    }
    if(!validateField(this.state.person.names)){
      errores.names = 'Required field';
      formValid = false;
    } 

    if(this.state.company.phone_number && this.state.company.phone_number.length > 20)
    {
      errores.phone_number = 'Incorrect phone number format';
      formValid = false;
    }  

    if(!validateField(this.state.company.name)){
      errores.name = 'Required field';
      formValid = false;
    } 
    if(!validateField(this.state.company.address)){
      errores.address = 'Required field';
      formValid = false;
    } 

    if(!validateField(this.state.company.phone_number)){
      errores.phone_number = 'Required field';
      formValid = false;
    } 

    if(!validateField(this.state.company.country)){
      errores.country = 'Required field';
      formValid = false;
    } 

    
    if (!validateEmail(this.state.user.email)) 
    {
      errores.email= 'Not valid email';
      formValid = false;
    }
    this.setState({
      errores: errores,
      formValid: formValid,
    });
  }


  closeErrorDialog = ()=>{
    this.setState({openAlert:false});
  }


  handleChangeClientCountry(val)
  {
   this.handleChangeCompany({target:{value:val.value,id:'country',name:'country'}}) 
  }
  
  getValueCountry(opts, id) {
    let realValue = opts.find(o => o.value === id);
    return realValue;
  }

  componentDidMount(){
     const script = document.createElement("script");

    script.src = "https://pems.outseta.com/Scripts/client/dist/outseta.auth.widget.min.js";
    
    script.setAttribute("data-popup-selector", "#btnRegister");
    script.setAttribute("data-widget-mode", "register");
    

    document.body.appendChild(script);
  }

  render() {
    
    const { classes } = this.props;
    return (
       <main className={classes.main}>
       {localStorage.getItem("logged") ? (
          <Redirect
            push
            to={
              '/'
            }
          />
        ):null}
        <Paper className={classes.paper}>
          <div style={{backgroundColor:"#a0a0a0"}}>
              <div className={classes.avatar}  style={{marginBottom:'0%',maxHeight:40,/* minWidth:80, minHeight:80,*/ borderRadius:0}} variant="square">
                <img src={IpmIcon} style={{marginLeft:"20px", marginTop:"10px"}} width="50px" height="70px" alt="logo"></img>
              </div>
              </div>
          <Typography component="h1" variant="h5" style={{color:"#5a6271", marginTop:"15px", marginBottom:"-5px"}}>
            Sign Up
          </Typography>
         <form className={classes.form} noValidate>
            <Grid item xs={12}  className={classes.myGrid}>
              <Typography component="h1" variant="h6" style={{color:"#5a6271", marginTop:"15px", marginBottom:"-5px"}}>
                User Information:
              </Typography>
            </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} className={classes.myGrid}>
              <TextField
                autoComplete="fname"
                name="names"
                variant="outlined"
                required
                fullWidth
                id="names"
                label="First Name"
                autoFocus
                value={this.state.person.names ? this.state.person.names : ''}
                onChange={this.handleChangePerson} 
                error={this.state.errores.names}
                helperText={this.state.errores.names}
              />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="surnames"
                label="Last Name"
                name="surnames"
                autoComplete="lname"
                value={this.state.person.surnames ? this.state.person.surnames : ''}
                onChange={this.handleChangePerson} 
                error={this.state.errores.surnames}
                helperText={this.state.errores.surnames}
              />
            </Grid>
            <Grid item xs={6} sm={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                value={this.state.user.username ? this.state.user.username : ''}
                onChange={this.handleChangeUser} 
                error={this.state.errores.username}
                helperText={this.state.errores.username}
              />
            </Grid>
            <Grid item xs={6} sm={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={this.state.user.email ? this.state.user.email : ''}
                onChange={this.handleChangeUser}
                error={this.state.errores.email}
                helperText={this.state.errores.email}
              />
          </Grid>
            <Grid item xs={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={this.state.user.password ? this.state.user.password : ''}
                onChange={this.handleChangeUser} 
                error={this.state.errores.password}
                helperText={this.state.errores.password}
              />
            </Grid>
             <Grid item xs={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password2"
                label="Repeat password"
                type="password"
                id="password2"
                autoComplete="current-password"
                value={this.state.user.password2 ? this.state.user.password2: ''}
                onChange={this.handleChangeUser} 
                error={this.state.errores.password2}
                helperText={this.state.errores.password2}
              />
            </Grid>
            <Grid item xs={12}  className={classes.myGrid}>
              <Typography component="h1" variant="h6" style={{color:"#5a6271", marginTop:"15px", marginBottom:"-5px"}}>
                Business Information:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="name"
                label="Name"
                name="name"
                autoComplete="name"
                value={this.state.company.name ? this.state.company.name : ''}
                onChange={this.handleChangeCompany} 
                error={this.state.errores.name}
                helperText={this.state.errores.name}
              />
            </Grid>
            <Grid item xs={6} sm={6} className={classes.myGrid}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="address"
                label="Address"
                name="address"
                autoComplete="Address"
                value={this.state.company.address? this.state.company.address : ''}
                onChange={this.handleChangeCompany} 
                error={this.state.errores.address}
                helperText={this.state.errores.address}
              />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.myGrid}>
            <TextField
              variant="outlined"
              required
              id="phone_number"
              name="phone_number"
              label="Phone Number"
              fullWidth
              autoComplete="Phone Number"
              value={this.state.company.phone_number? this.state.company.phone_number : ''}
              onChange={this.handleChangeCompany}
              error={this.state.errores.phone_number}
              helperText={this.state.errores.phone_number}
            />
            </Grid>
            <Grid item xs={12} sm={6} style={{marginTop:'20px'}}>
              <div >
                <InputLabel htmlFor="country" style={{marginRight:'10px'}}>Country</InputLabel>
                <Select
                  required
                  id="country"
                  name="country"
                  value={this.getValueCountry(Countries,this.state.company.country)}
                  onChange={this.handleChangeClientCountry}
                  error={this.state.errores.country}
                  errorText={this.state.errores.country}
                  helperText={this.state.errores.country}
                  options={Countries}
                  styles={{control: (provided,state) => (this.state.errores.country ? {...provided,borderColor: 'red', } : provided)}}
                >
                </Select>
              </div>
            </Grid>
          </Grid>
          <span style={{color:"red"}}>{this.state.errores.message}</span>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!this.state.formValid}
            onClick={this.doRegister}
            style={{marginTop:'5%'}}
          >
            Sign Up
          </Button>
          <Grid container justify="flex-end" style={{marginTop:'4%'}}>
            <Grid item>
              <Link component={RouterLink} to="/login">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>

        <Button
          id="btnRegister"
          >
            RegisterOutseta
          </Button>
        </form>
        </Paper>
        <Alerta message={this.state.AlertaMessage} openAlert={this.state.openAlert} closeErrorDialog={this.closeErrorDialog}/>
      </main>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    register: state.register,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/register/DefaultPage.js